import fs from 'node:fs';
import { isMainThread } from 'node:worker_threads';
import { assertBackgroundIndexingAllowed } from '../../../files/browser/in-flight.js';
import { isCliImmediateShutdownRequested } from '../../../runtime/cli-process-interrupt.js';
import { CliSqliteInterrupted } from '../../../sqlite/code-nav-cache/database.js';
import { isSymbolIndexDeferredError } from '../deferred-indexing.js';

export const MAX_INDEX_FILE_BYTES = 512 * 1024;

export function assertSymbolIndexNotShutdown(): void {
  if (isCliImmediateShutdownRequested()) throw new CliSqliteInterrupted();
}

function readIndexSourceFileSync(absPath: string): string | null {
  assertSymbolIndexNotShutdown();
  assertBackgroundIndexingAllowed();
  const stat = fs.statSync(absPath);
  if (!stat.isFile() || stat.size > MAX_INDEX_FILE_BYTES) return null;
  assertBackgroundIndexingAllowed();
  return fs.readFileSync(absPath, 'utf8');
}

export async function readIndexSourceFile(absPath: string): Promise<string | null> {
  try {
    if (!isMainThread) {
      return readIndexSourceFileSync(absPath);
    }
    assertSymbolIndexNotShutdown();
    assertBackgroundIndexingAllowed();
    const stat = await fs.promises.stat(absPath);
    if (!stat.isFile() || stat.size > MAX_INDEX_FILE_BYTES) return null;
    assertBackgroundIndexingAllowed();
    return await fs.promises.readFile(absPath, 'utf8');
  } catch (err) {
    if (isSymbolIndexDeferredError(err)) throw err;
    return null;
  }
}
